import { Route, Routes } from 'react-router-dom';
import ContextInfo from './context/contextInfo';
import IEC104 from './pages/iec104/IEC104';
import Login from './pages/Login/Login';
import Pages from './routes/Pages';
import ContextCat from './context/contextCategory/contextCat';

function App() {
  return (
    <ContextInfo>
        <Routes>
          <Route path="/iec104" element={<IEC104 />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/*" element={<Pages />} />
        </Routes>
    </ContextInfo>
  );
}

export default App;
